module.exports = {
      id: "strawberry-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "svg-sprite-c71831da97eff2ec188167649c252867.svg#strawberry",
      toString: function () {
        return this.url;
      }
    }